////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import { fr } from 'date-fns/locale'
import styled from 'styled-components'
import moment from 'moment'
///////COMPONENTS///////
import '../../../theme/DatePickerStyle/react-datepicker.css'
import theme from '../../../theme/theme'
import DateFormat from '../../../helpers/dateFormat'
/////////ASSETS/////////
import imgValidate from '../../../assets/icones/global/check.svg'
import imgCancel from '../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModalDateTimeWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: ${(props) => (props.noInterval ? 'center' : 'space-around')};
	padding: 26px;
	& > * {
		font-size: ${(props) => props.theme.font.fm} !important;
	}
	& .react-datepicker__day--keyboard-selected {
		background-color: ${(props) => (props.firstDate ? null : props.theme.colors.datePickerBg)};
		color: ${(props) => (props.firstDate ? null : props.theme.colors.black)};
		border: 1px solid ${(props) => (props.firstDate ? null : props.theme.colors.primary)};
		font-weight: 400;
	}
	& div.react-datepicker__week > div:focus {
		outline: none;
	}
`
const CalendarsWrapper = styled.div`
	display: flex;
	justify-content: ${(props) => (props.noInterval ? 'center' : 'space-between')};
	align-items: flex-start;
	margin-top: ${(props) => (props.marginTop ? '20px' : '0')};
	height: ${(props) => (props.height ? props.height + 'px' : 'inherit')};
	& * {
		font-size: ${(props) => props.theme.font.fs} !important;
	}
	& .react-datepicker__day-name,
	& .react-datepicker__day,
	& .react-datepicker__time-name {
		width: 33px !important;
		height: 33px !important;
		border-radius: 0px !important;
	}
`
const InputsWrapper = styled.div`
	width: ${(props) => (props.noInterval ? 'auto' : '506px')};
	display: flex;
	justify-content: ${(props) => (props.noInterval ? 'center' : 'space-between')};
	align-items: center;
	margin-bottom: 11px;
	font-size: 16px;
`
const PaireInputWrapper = styled.div`
	display: flex;
	width: 231px;
	justify-content: ${(props) => (props.noInterval ? 'center' : 'space-around')};
	z-index: 2;
`
const InputStyle = styled.div`
	line-height: 32px;
	padding: 0px 10px;
	border: 1px solid ${(props) => props.theme.colors.datePicker.borderInput};
	border-radius: 3px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: ${(props) => props.theme.font.fm};
	width: 90px;
`
const TextAndInputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	/* borders for inputs and datepicker inputs */
	& > div > div > input {
		border: 1px solid ${(props) => props.theme.colors.datePicker.borderInput};
	}
	& > div > div > div > input {
		border: 1px solid ${(props) => props.theme.colors.datePicker.borderInput};
	}
	& .react-datepicker__input-container {
		line-height: normal;
	}
	& .react-datepicker__input-container > input {
		width: auto;
		height: auto;
		line-height: 32px;
		padding: 0px 10px;
		width: 90px;
	}
	& .react-datepicker-time__header {
		font-size: ${(props) => props.theme.font.fs};
	}
	& .react-datepicker--time-only .react-datepicker__time-container {
		font-size: ${(props) => props.theme.font.fs} !important;
		width: 110px;
	}
`
const TextBelowInput = styled.p`
	color: ${(props) => props.theme.colors.tabText};
	margin: 0;
	padding-bottom: 5px;
	font-weight: bold;
`
const ButtonBottm = styled.div`
	text-align: center;
	border-radius: 3px;
	margin-right: ${(props) => (props.margin ? `${props.margin}px` : '0')};
	color: white;
	font-weight: bold;
	line-height: 32px;
	padding: 2px 11px 0px;
	background-color: ${(props) => (props.disabled ? props.theme.colors.grey : props.bcg)};
	opacity: ${(props) => (props.disabled ? 0.5 : 1)};
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	:hover {
		background-color: ${(props) => props.hover};
	}
	transition: background-color 0.1s;
	& > img {
		height: 10px;
	}
`
const BottomButtonWrapper = styled.div`
	display: flex;
	justify-content: ${(props) => (props.noInterval ? 'center' : 'space-around')};
	height: 32px;
	position: relative;
	& .validate {
		padding: 2px 9px 0px;
		margin-right: 0px;
	}
	margin: ${(props) => (props.noInterval ? '0px 8px' : '0px')};
`

const ErrorMsg = styled.span`
	display: flex;
	position: absolute;
	top: -17px;
	right: 0px;
	direction: rtl;
`
/////////STYLED/////////

const DateTimePicker = ({
	startDate,
	endDate,
	startDateHandleChange,
	endDateHandleChange,
	startTimeHandleChange,
	endTimeHandleChange,
	formatDate,
	cancelUpdateHandler,
	toDayHandler,
	weekSelectHandler,
	monthSelectHandler,
	updateDate,
	translations,
	noInterval,
	noPastDate,
	disableStartDate = false,
	disableEndDate = false,
	noTime = false,
	priorStartLimit = false,
	priorEndLimit = false,
}) => {
	const isSameDay = moment(startDate).isSame(moment(endDate), 'day')
	const isToDay = moment(startDate).isSame(moment(), 'day')
	const dayDate = moment().calendar('sameDay')
	const selectedEndDate = moment(endDate).calendar('sameDay')

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalDateTimeWrapper noInterval>
			<InputsWrapper noInterval={noInterval}>
				<PaireInputWrapper noInterval={noInterval}>
					<TextAndInputWrapper>
						<TextBelowInput>
							{translations['modal__dateSelection__startDate']}
							{/* Date de début */}
						</TextBelowInput>
						<InputStyle>{formatDate(startDate)}</InputStyle>
					</TextAndInputWrapper>
					{noTime ? (
						''
					) : (
						<TextAndInputWrapper>
							<TextBelowInput>
								{translations['modal__dateSelection__startHour']}
								{/* Heure de début */}
							</TextBelowInput>
							{!noInterval && (
								<DatePicker
									selected={startDate}
									onChange={startTimeHandleChange}
									showTimeSelect
									showTimeSelectOnly
									timeIntervals={15}
									timeCaption="Time"
									timeFormat="HH:mm"
									dateFormat="HH:mm"
									disabled={disableStartDate}
									minTime={isToDay ? (noPastDate ? moment().toDate() : moment().startOf('day')) : moment().startOf('day')}
									maxTime={isSameDay ? moment(endDate).subtract(15, 'minutes').toDate() : moment(startDate).endOf('day').toDate()}
								/>
							)}
							{noInterval && (
								<DatePicker
									selected={startDate}
									onChange={startTimeHandleChange}
									showTimeSelect
									showTimeSelectOnly
									timeIntervals={15}
									timeCaption="Time"
									timeFormat="HH:mm"
									dateFormat="HH:mm"
									disabled={disableStartDate}
									minTime={
										noPastDate ? (startDate < moment().toDate() ? moment().toDate() : moment().startOf('day')) : moment().toDate()
									}
									maxTime={moment(startDate).endOf('day').toDate()}
								/>
							)}
						</TextAndInputWrapper>
					)}
				</PaireInputWrapper>
				{!noInterval && (
					<PaireInputWrapper>
						<TextAndInputWrapper>
							<TextBelowInput>
								{translations['modal__dateSelection__endDate']}
								{/* Date de fin */}
							</TextBelowInput>
							<InputStyle>{formatDate(endDate)}</InputStyle>
						</TextAndInputWrapper>
						{noTime ? (
							''
						) : (
							<TextAndInputWrapper>
								<TextBelowInput>
									{translations['modal__dateSelection__endHour']}
									{/* Heure de fin */}
								</TextBelowInput>

								{!disableStartDate && (
									<DatePicker
										selected={endDate}
										onChange={endTimeHandleChange}
										showTimeSelect
										showTimeSelectOnly
										// tenter un autre jsx avec diabled en flag
										timeIntervals={15}
										timeCaption="Time"
										timeFormat="HH:mm"
										dateFormat="HH:mm"
										minTime={disableStartDate ? moment().add(15, 'minutes').toDate() : moment(endDate).startOf('day')}
										maxTime={moment(endDate).endOf('day').toDate()}
									/>
								)}
								{disableStartDate && (
									<DatePicker
										selected={endDate}
										onChange={endTimeHandleChange}
										showTimeSelect
										showTimeSelectOnly
										disableEndDate={disableEndDate}
										timeIntervals={15}
										timeCaption="Time"
										timeFormat="HH:mm"
										dateFormat="HH:mm"
										minTime={dayDate === selectedEndDate ? moment().add(15, 'minutes').toDate() : moment(endDate).startOf('day')}
										maxTime={moment(endDate).endOf('day').toDate()}
									/>
								)}
							</TextAndInputWrapper>
						)}
					</PaireInputWrapper>
				)}
			</InputsWrapper>
			<CalendarsWrapper height={300} noInterval={noInterval}>
				<DatePicker
					selected={startDate}
					onChange={startDateHandleChange}
					disabled={disableStartDate}
					locale={fr}
					maxDate={
						disableStartDate
							? moment().subtract(1, 'days').toDate()
							: noInterval
							? priorEndLimit
								? moment(priorEndLimit).toDate()
								: null
							: moment(endDate).subtract(15, 'minutes').toDate()
					}
					minDate={priorStartLimit ? moment(priorStartLimit).toDate() : noPastDate ? moment().toDate() : null}
					inline
				/>
				{!noInterval && (
					<DatePicker
						selected={endDate}
						onChange={endDateHandleChange}
						locale={fr}
						disabled={disableEndDate}
						inline
						minDate={
							disableEndDate
								? moment().add(1, 'days').toDate()
								: disableStartDate
								? moment().toDate()
								: moment(startDate).add(15, 'minutes').toDate()
						}
						maxDate={disableEndDate ? moment().subtract(1, 'days').toDate() : null}
					/>
				)}
			</CalendarsWrapper>

			<CalendarsWrapper marginTop>
				<BottomButtonWrapper noInterval={noInterval}>
					<ButtonBottm bcg={theme.colors.primary} margin={15} onClick={toDayHandler} hover={theme.colors.hoverPrimary}>
						{translations['common__text__today']}
						{/* Aujourd'hui */}
					</ButtonBottm>
					<ButtonBottm onClick={weekSelectHandler} bcg={theme.colors.primary} margin={15} hover={theme.colors.hoverPrimary}>
						{translations['common__text__week']}
						{/* Semaine */}
					</ButtonBottm>
					<ButtonBottm bcg={theme.colors.primary} onClick={monthSelectHandler} hover={theme.colors.hoverPrimary}>
						{translations['common__text__month']}
						{/* Mois */}
					</ButtonBottm>
				</BottomButtonWrapper>
				<BottomButtonWrapper noInterval={noInterval}>
					<ButtonBottm onClick={cancelUpdateHandler} bcg={theme.colors.error} margin={10} hover={theme.colors.hoverError}>
						<img src={imgCancel} />
					</ButtonBottm>
					<ButtonBottm
						className="validate"
						onClick={updateDate}
						bcg={theme.colors.validation}
						margin={15}
						disabled={!noInterval && DateFormat.dateEndIsBefore(startDate, endDate)}
						hover={theme.colors.hoverValidation}
					>
						<img src={imgValidate} />
					</ButtonBottm>
					{/*<Button
                img={imgValidate}
                actionHandler={updateDate}
                bgColor={theme.colors.validation}
                disabled={DateFormat.dateEndIsBefore(startDate, endDate)}
            />*/}
					{!noInterval && DateFormat.dateEndIsBefore(startDate, endDate) && (
						<ErrorMsg>{translations['common__message__dateSelection_update_invalidRangeDate']}</ErrorMsg>
					)}
				</BottomButtonWrapper>
			</CalendarsWrapper>
		</ModalDateTimeWrapper>
	)
}

DateTimePicker.propTypes = {
	startDate: PropTypes.object,
	endDate: PropTypes.object,
	startDateHandleChange: PropTypes.func,
	endDateHandleChange: PropTypes.func,
	startTimeHandleChange: PropTypes.func,
	endTimeHandleChange: PropTypes.func,
	formatDate: PropTypes.func,
	cancelUpdateHandler: PropTypes.func,
	updateDate: PropTypes.func,
	translations: PropTypes.object,
}

export default DateTimePicker
